export const SIGNIN_PAGES = ["/signin", "/signup"];
